import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-bus-details-more',
  templateUrl: './bus-details-more.component.html',
  styleUrls: ['./bus-details-more.component.scss']
})
export class BusDetailsMoreComponent implements OnInit {

busDetails: any;

constructor(
  @Inject(MAT_DIALOG_DATA) public data,
  private modalService: ModalService,
) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  close(){
    this.modalService.hideBusMoreDetails();
  }

  maskString(str: string): string {
    if (!str) return "";

    if (str.length <= 2) return str; // nothing to mask

    const visible = str.slice(0, 2);
    const masked = "*".repeat(str.length - 2);

    return visible + masked;
  }
}

